import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Card,
  Table,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function AppliedCampaign() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
 
  const [allCategory, setAllCategory] = useState([]);
 
  const [searchData, setSearchData] = useState([]);
 
  const [spinner, setSpinner] = useState(true);
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food-admin/get-all-food-campaign-restaurant-applied`)
      .then((res) => {
        console.log("categoiryeueye", res.data.foodCampaignApproveDetails);
        setSpinner(false);
        setAllCategory(res.data.foodCampaignApproveDetails);
        setSearchData(res.data.foodCampaignApproveDetails);
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Category.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllCategory(filteredData);
  }
 
  return (
    <Col lg={12}>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
         
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Restaurant Name</strong>
                    </th>

                    <th>
                      <strong>Image</strong>
                    </th>
                    <th>
                      <strong>Campaign Name</strong>
                    </th>
                    <th>
                      <strong>Image</strong>
                    </th>
                   
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allCategory &&
                    allCategory.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>{val.RestaurantName}</td>
                        <td>
                          <img
                            src={val.RestaurantId.RImage}
                            height={40}
                            width={40}
                            alt="profile"
                          />
                        </td>
                        <td>{val.CampaignName}</td>
                        <td>
                          <img
                            src={val.CampaignId.Image}
                            height={40}
                            width={40}
                            alt="profile"
                          />
                        </td>
                        <td>
                         <button className="btn btn-primary"
                         onClick={()=>{history.push(`View-Campaign`,{data:val})}}
                         >View</button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCategory && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCategory
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default AppliedCampaign;

